// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__em1Y9","left":"styles_left__2KrVj","right":"styles_right__MHDhM","alert":"styles_alert__2DS6s"};